import { toast } from "react-toastify";
import { ChackImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetWorkingProcess =
  ({ callback, is_active = null }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.working_process.get;

      const response = await PostFunction({
        data: { is_active },
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetCountries =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.country.get;
      const response = await PostFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetGroups =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.groups.get;
      const response = await PostFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageWorkingProcess =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      if (editMode) {
        bodyFormData.append("id", values?.id);
      }

      if (CheckDataIfExit(values?.order_number)) {
        bodyFormData.append("order_number", values?.order_number);
      } else {
        bodyFormData.append("order_number", "");
      }
      if (CheckDataIfExit(values?.type)) {
        bodyFormData.append("type", values?.type?.trim());
      } else {
        bodyFormData.append("type", "");
      }
      if (CheckDataIfExit(values?.text)) {
        bodyFormData.append("text", values?.text?.trim());
      } else {
        bodyFormData.append("text", "");
      }
      if (CheckDataIfExit(values?.description)) {
        bodyFormData.append("description", values?.description?.trim());
      } else {
        bodyFormData.append("description", "");
      }

      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        ChackImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? UrlApi.working_process.edit
          : UrlApi.working_process.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditWorkingProcess =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          id: id,
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.working_process.edit,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteWorkingProcess =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      console.log({ idididididid: id });
      let data = {
        idscountryprocesstype: id,
      };
      const response = await PostFunction({
        data,
        Route: UrlApi.working_process.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
